import React from 'react';
import { FlexboxColumn } from '../action/Flexbox';
import BackgroundVideo from '../BackgroundVideo/BackgroundVideo';
import ThemedText from '../theme/ThemedText';
import ThemeLogo from '../theme/ThemeLogo';
import LoginButton from './LoginButton';
import './LoginPage.scss';

const LoginPage = () => {
  return (
    <BackgroundVideo videoUrl='https://dskhnex0aho1n.cloudfront.net/public/main-vid.mp4'>
      <FlexboxColumn className='loginpage_wrapper' justifyContent='flex-start' gap='1rem' alignItems={'flex-start'}>
        <ThemeLogo className='loginpage_wrapper__logo' icon={'mercleWhite'} />
        <div>
          <ThemedText.H2 >Welcome to the Mercle app.</ThemedText.H2>
          <ThemedText.H5>
            An application layer created for the end-user experience <br /> that leverages HumanED & OpenRep.
            <br /> Think of it as a playground that showcases how <br /> users' internet experience can transform by
            <br /> owning their digital identity and reputation.
          </ThemedText.H5>
        </div>
        <LoginButton />
      </FlexboxColumn>
    </BackgroundVideo>
  );
};

export default LoginPage;
